import styled, { css } from 'styled-components';
import { ifProp, palette } from 'styled-tools';

import { fontWeight, FontWeights, minWidth, Text } from '@calm-web/design-system';

export const Wrapper = styled.section`
	background: ${palette('gradientCalmBrand')};
	color: ${palette('white')};
	overflow: hidden;
	position: relative;
	text-align: center;

	${minWidth('desktop')} {
		text-align: left;
	}
`;

export const BackgroundWrapper = styled.section`
	padding-bottom: 60px;
	background: ${palette('gradientDarkBlue')};
	min-height: 100vh;

	${minWidth('desktop')} {
		padding-bottom: 140px;
	}
`;

export const JasperLake = styled.div`
	height: 250px;
	margin-bottom: 0;
	position: relative;
	z-index: 0;

	mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) 80%, rgba(0, 0, 0, 0) 100%);
	-webkit-mask-image: linear-gradient(
		to bottom,
		rgba(0, 0, 0, 1) 0%,
		rgba(0, 0, 0, 1) 80%,
		rgba(0, 0, 0, 0) 100%
	);

	${minWidth('tablet')} {
		height: 480px;
		margin-bottom: 0;
	}
`;

export const JoinContent = styled.div`
	align-items: center;
	display: flex;
	justify-content: center;
	flex-direction: column;
`;

export const Content = styled.div`
	grid-column: 1 / 5;
	padding: 40px 0;

	${minWidth('desktop')} {
		grid-column: 1 / 3;
		padding: 136px 0 50px;
	}
`;

export const Heading = styled(Text)`
	display: flex;
	line-height: 1.5;
	font-size: 28px;
	${fontWeight(FontWeights.Medium)};
	margin-bottom: 24px;

	${minWidth('tablet')} {
		${fontWeight(FontWeights.Regular)};
		font-size: 49.5px;
		line-height: 1.5;
	}
`;

export const JoinHeading = styled(Text)`
	color: ${palette('white')};
	font-size: 25px;
	${fontWeight(FontWeights.Demi)};
	padding: 0 18px;
	text-align: center;
	margin-bottom: 30px;

	${minWidth('tablet')} {
		font-size: 31.5px;
	}
`;

export const Subheading = styled(Text)`
	display: flex;
	line-height: 1.5;
	font-size: 20px;
	${fontWeight(FontWeights.Regular)};
	margin-bottom: 50px;

	${minWidth('tablet')} {
		font-size: 31.5px;
	}
`;

export const ButtonWrapper = styled.div<{ isJoinFlow?: boolean }>`
	margin: 0 auto 48px;
	max-width: 328px;
	width: 100%;

	${ifProp(
		'isJoinFlow',
		css`
			gap: 16px;
			display: flex;
			flex-direction: column;

			${minWidth('tablet')} {
				padding-top: 50px;
			}
		`,
	)}

	${minWidth('mobileLarge')} {
		width: 50%;
	}

	${minWidth('desktop')} {
		margin: 0 0 48px;
		width: 75%;
	}
`;

export const DeviceImageWrapper = styled.div`
	grid-column: 1 / 5;
	height: auto;
	margin: 0 auto;
	width: 80%;

	${minWidth('desktop')} {
		grid-column: 3 / 5;
		margin-top: auto;
		width: 100%;
	}
`;
